import { render, staticRenderFns } from "./PublisherPerformance.vue?vue&type=template&id=02860a94&"
import script from "./PublisherPerformance.vue?vue&type=script&lang=js&"
export * from "./PublisherPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports